import React from "react";
import CrudManager from "../components/CrudManager";
import { api, resolveMediaUrl } from "../../lib/api";

const fields = [
  { name: "image.url", label: "Banner Image", type: "image", required: true, fullWidth: true },
  { name: "image.alt", label: "Image Alt Text" },
  { name: "position", label: "Display Position", type: "number", defaultValue: 0, min: 0 },
  { name: "isActive", label: "Banner Status", type: "checkbox", defaultValue: true, help: "Show on website" },
];

export default function Banners() {
  return <CrudManager title="Banners" singular="Banner" fields={fields} apiResource={api.banners} columns={[
    { label: "Preview", render: (item) => item.image?.url ? <img className="admin-table-image" src={resolveMediaUrl(item.image.url)} alt={item.image.alt || "Banner"} /> : "—" },
    { label: "Position", accessor: "position" },
    { label: "Status", render: (item) => <span className={`admin-badge ${item.isActive ? "success" : "muted"}`}>{item.isActive ? "Active" : "Hidden"}</span> },
  ]} />;
}
